import React, { useState, useEffect, useRef } from 'react';
 

const services = [
  {
    id: "01",
    category: "Experience",
    title: "Customer Experience and CPQ",
    image: "./images/customer-experience.jpg",
    bgGradient: "linear-gradient(135deg, #1e0d33 0%, #0d0614 100%)"
  },
  {
    id: "02",
    category: "Logistics",
    title: "Supply Chain Optimization",
    image: "./images/supply-chain-optimization.jpg",
    bgGradient: "linear-gradient(135deg, #0d281e 0%, #05100c 100%)"
  },
  {
    id: "03",
    category: "Intelligence",
    title: "Big Data and Analytics",
    image: "./images/big-data-and-analytics.jpg",
    bgGradient: "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)"
  },
  {
    id: "04",
    category: "Design",
    title: "Mobility and UX",
    image: "./images/mobility-and-ux.jpg",
    bgGradient: "linear-gradient(135deg, #2b1055 0%, #7597de 100%)"
  },
  {
    id: "05",
    category: "Cognitive",
    title: "AI and ML",
    image: "./images/ai-and-ml.jpg",
    bgGradient: "linear-gradient(135deg, #130cb7 0%, #52e5e7 100%)"
  },
  {
    id: "06",
    category: "Automation",
    title: "Robotic Process Automation",
    image: "./images/robotic-process-automation.jpg",
    bgGradient: "linear-gradient(135deg, #141e30 0%, #243b55 100%)"
  },
  {
    id: "07",
    category: "Connectivity",
    title: "Internet of Things",
    image: "./images/internet-of-things.jpg",
    bgGradient: "linear-gradient(135deg, #000428 0%, #004e92 100%)"
  },
  {
    id: "08",
    category: "Strategy",
    title: "Human Capital Management",
    image: "./images/human-capital-management.jpg",
    bgGradient: "linear-gradient(135deg, #16222f 0%, #363795 100%)"
  }
];

export default function DigitalTransformation() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const autoSlideInterval = useRef(null);

  // Auto-slide loop logic
  useEffect(() => {
    if (!isPaused) {
      autoSlideInterval.current = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % services.length);
      }, 4000); // Transitions every 4 seconds
    }

    return () => {
      if (autoSlideInterval.current) {
        clearInterval(autoSlideInterval.current);
      }
    };
  }, [isPaused]);

  return (
    <div 
      className="dt-container container-fluid d-flex align-items-center position-relative overflow-hidden"
      style={{
        background: services[activeIndex].bgGradient,
        transition: 'background 0.6s cubic-bezier(0.25, 1, 0.5, 1)'
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* Background Interactive Image Reveal */}
      <div className="dt-bg-image-wrapper">
        {services.map((service, index) => (
          <div
            key={service.id}
            className={`dt-bg-image-slice ${activeIndex === index ? 'active' : ''}`}
            style={{ backgroundImage: `url(${service.image})` }}
          />
        ))}
        <div className="dt-overlay" />
      </div>

      <div className="container py-10 z-2">
        
        <h1 className="agency-headline text-white text-center font-weight-bold text-uppercase m-0">
          <span className="line-one d-block">  Our </span>
          
          <span className="line-two d-block">
            <span className="text-outline">Indu</span>
            <span className="text-accent-solid text-lime">S</span>
            <span className="text-outline">tries</span>
            <span className="text-solid">   Solutions</span>
          </span>
                    
        </h1>
        <div className="row">
          <div className="col-12 col-lg-8">
            <div className="dt-list">
              {services.map((service, index) => (
                <div
                  key={service.id}
                  className={`dt-item d-flex align-items-start py-3 py-md-4 border-bottom border-secondary border-opacity-25 ${
                    activeIndex === index ? 'is-active' : 'is-dimmed'
                  }`}
                  onMouseEnter={() => setActiveIndex(index)}
                >
                  <div className="dt-meta me-4">
                    <span className="dt-category d-block">{service.category}</span>
                    <span className="dt-id d-block">{service.id}.</span>
                  </div>
                  <h2 className="dt-title mb-0 flex-grow-1">
                    {service.title}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}